import ErrorPage from '@/views/Error.vue'
import Index from '@/views/Index.vue'

export const genericRoutes = [
  { path: '', name: 'index', component: Index },
  {
    path: '/error',
    name: 'error',
    component: ErrorPage,
  },
]
